<template>
  <v-card>
    <v-toolbar flat>
      <v-text-field
          v-model.trim="quickSearchString"
          label="Recherche rapide"
          solo
          clearable
      />
      <v-spacer/>
      <v-toolbar-items class="mr-2">
        <v-select
          v-model="sorter"
          prepend-icon="swap_vert"
          @click:prepend="toggleSort"
          label="Ranger par..."
          :items="usableHeaders"
          item-text="label"
          item-value="value"
          clearable
        />
      </v-toolbar-items>
      <ViewSelector
        :hasMap="hasMap"
        :hasLine="hasLine"
        :hasList="true"
        :hasCard="hasCard"
        :selectView="selectView"
        :value="listView"
        />
    </v-toolbar>
    <v-card-text class="px-0 py-0">
      <DataForm
        :fields="searchFields"
        :form="searchForm"
        :updateField="updateSearchField"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn flat @click.stop="handleReset">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn color="primary" @click.stop="handleSearch">
        <v-icon>search</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DataForm from '@/components/form/DataForm'
import ViewSelector from '@/components/ViewSelector'
export default {
  components: {
    DataForm,
    ViewSelector,
  },
  props: {
    headers: Array,
    handleSearch: Function,
    handleReset: Function,
    searchFields: Array,
    searchForm: Object,
    updateSearchField: Function,
    hasMap: Boolean,
    listView: String,
    hasLine: Boolean,
    hasCard: Boolean,
    hasList: Boolean,
    selectView: Function,
    quickSearch: String,
    updateQuickSearch: Function,
    pagination: Object,
    handleSort: Function,
  },
  data: () => ({
    sortBy: null,
  }),
  computed: {
    sorter: {
      get () { return this.pagination.sortBy },
      set (value) {
        this.sortBy = value
        this.handleSort(value)
      },
    },
    quickSearchString: {
      get () { return this.quickSearch },
      set (value) { this.updateQuickSearch(value) },
    },
    usableHeaders () { return this.headers },
  },
  methods: {
    toggleSort () {
      this.handleSort(this.sortBy)
    },
  },
}
</script>

<style>

</style>
